import React from 'react'
import AdminLayout from '../commonlayouts/adminlayout'
import { Link } from 'react-router-dom'

export const AdminDashboard = () => {
  return (
    <AdminLayout>
     <div className='container'>
<div className='row'>
<div className='col-sm-12 col-lg-6 col-xl-6 col-md-6  mt-3'>
<h2 className="" style={{color:"#00a7ac"}} >Dashboard</h2>


</div>

<div className='col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-3 ' >

</div>
</div>
<hr />
<div class="row mt-5">
<div class="col-sm-12 col-lg-4 col-xl-4">
<Link to="/Admin/ListofallClients" >
<div class="card shadow-sm p-3 text-center mt-3 " style={{borderTop:'4px solid #00a7ac',borderRadius:'20px',borderLeft:'none',borderRight:'none',borderBottom:'none',height:'150px',textAlign:'center'}}>
<div class="text-center">
<i class="fa fa-users" style={{color:'#00a7ac',fontSize:'30px'}}></i>

</div>
<h4>Clients</h4>
{/* <p>25</p> */}
</div>
</Link>
</div>
</div>
</div>



       </AdminLayout>
  )
}
